import { render, staticRenderFns } from "./ProductBreakdown.vue?vue&type=template&id=5227e331&"
import script from "./ProductBreakdown.vue?vue&type=script&lang=js&"
export * from "./ProductBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports